import axios from "axios";
import { getAuthorizationHeaders, handleUnauthorized } from "./session";

const AxiosRequest = async (method, url, data) => {
  const config = {
    headers: getAuthorizationHeaders(),
  };

  try {
    switch (method.toLowerCase()) {
      case "get":
        return await axios[method](url, config);
      case "post":
        return await axios[method](url, data, config);
      case "put":
        return await axios[method](url, data, config);
      default:
        break;
    }
  } catch (error) {
    handleUnauthorized(error);
    throw error;
  }
};

export default AxiosRequest;
